import { C } from "@angular/core/src/render3";
import { MensagemErroModel } from "../../../../shared/model/mensagem-erro.model";

export class DadosOnInitModelView{
  ListaAno : Ano[];
  ListaBanco: Banco[];
  ListaTipoReceita: TipoReceita[];
  ListaControleControleArquivoReceita:ControleArquivoReceita[];

  Sequencial: string;
  objetoMensagem: MensagemErroModel;
}

export class ControleArquivoReceitaFiltro{
  IdAno: string;
  IdBanco: string;
  IdTipoReceita: string; 
  Sequencial:string;
  DescricaoTipoReceita: string;
  IdSituacaoProcessamento: string;

}

export class ControleArquivoReceita{
  Id: number;
  NomeArquivo: string;
  SequencialRemessa: string;
  DataGeracao: Date;
  IdTipoReceita: number;
  DataTransmissao: Date;
  DescricaoTipoReceita:string;
  DataAtualizacao: Date;
  IdSituacaoProcessamento: number;
  DescricaoSituacaoProcessamento: string;
  IdSituacaoModificada: number;
}

export class Ano{
  IdAno: string;
  Descricao: string;
}

export class Banco{
  IdBanco: string;
  Descricao: string;

}

export class TipoReceita{
  IdTipoReceita: string;
  Descricao: string;
}

export class ValidacaoArquivo{
  NomeArquivo: string;
}

export class ControleArquivoReceitaModelView{
  ListaControleArquivoReceita : ControleArquivoReceita[];
  objetoMensagem: MensagemErroModel;
}



// WEBPACK FOOTER //
// ./src/app/ipm/geracao-arquivo-ipm/shared/model/geracao-arquivo-ipm.model.ts